import { formatUrl } from './format';

interface GetCopyLinkUrlArgs {
  slug: string;
  userDefinedPageUrl: string | undefined;
  affiliateAddress: string;
  affiliateCode?: string;
}

// Fuul hosted URL for program pages (uses NEXT_PUBLIC_FUULHOSTED_URL env var)
// Remove trailing slash to prevent double slashes in URLs
const fuulHostedUrl = (process.env.NEXT_PUBLIC_FUULHOSTED_URL || 'https://hub.fuul.xyz').replace(/\/+$/, '');

export const getIncentivesProgramUrl = (slug: string): string => `${fuulHostedUrl}/${slug}`;
export const getFuulHostedEndUserOnboardingUrl = (slug: string): string => `${fuulHostedUrl}/${slug}/landing`;

export const getEndUserOnboardingUrl = ({
  slug,
  affiliateAddress,
  userDefinedPageUrl,
  affiliateCode,
}: GetCopyLinkUrlArgs): string | null => {
  let baseUrl: string;

  if (userDefinedPageUrl) {
    try {
      // Try to format and validate the URL
      const formattedUrl = formatUrl(userDefinedPageUrl);
      // Test if it's a valid URL by trying to construct it
      new URL(formattedUrl);
      baseUrl = formattedUrl;
    } catch (_error) {
      // If URL is invalid, fallback to default URL
      baseUrl = `${fuulHostedUrl}/${slug}`;
    }
  } else {
    baseUrl = `${fuulHostedUrl}/${slug}/landing`;
  }

  try {
    const incentivesUrl = new URL(baseUrl);
    incentivesUrl.searchParams.set('referrer', affiliateCode ?? affiliateAddress);
    return incentivesUrl.toString();
  } catch (_error) {
    // If URL construction fails, return null
    return null;
  }
};
